module.exports = __webpack_public_path__ + "img/darren.47e90048.jpg";